import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { fetchHijriDate } from "../../services/hijriService";
import { fetchTimeFromCoords } from "../../services/timeService";

const CurrentTimeDisplay = ({ prayerData, onTimezoneChange }) => {
  const [currentTime, setCurrentTime] = useState(moment());
  const [hijriDate, setHijriDate] = useState("");
  const [masjidTimeZone, setMasjidTimeZone] = useState(null);

  // 🕒 Fetch timezone + hijri date initially
  useEffect(() => {
    if (!prayerData) return;

    const initTimeAndHijri = async () => {
      let now = moment();

      if (prayerData.startTimes?.latitude && prayerData.startTimes?.longitude) {
        try {
          const timeData = await fetchTimeFromCoords(
            prayerData.startTimes.latitude,
            prayerData.startTimes.longitude
          );

          //console.log("Time from API:", timeData);
          const tz = timeData.zoneName || "UTC";
          setMasjidTimeZone(tz);

          if (onTimezoneChange) onTimezoneChange(tz);

          now = moment.tz(timeData.formatted, tz);
        } catch (err) {
          console.warn("Fallback to local time (timezone fetch failed)", err);
        }
      }

      setCurrentTime(now);

      try {
        const hijri = await fetchHijriDate(
          now.format("DD-MM-YYYY"),
          prayerData.startTimes?.latitude,
          prayerData.startTimes?.longitude
        );
        setHijriDate(hijri);
      } catch (err) {
        console.warn("Hijri fetch failed", err);
      }
    };

    initTimeAndHijri();
  }, [prayerData, onTimezoneChange]);

  // 🕰️ Live clock tick based on API-derived time
  useEffect(() => {
    if (!masjidTimeZone) return;

    const timer = setInterval(() => {
          const now = moment.tz(masjidTimeZone);
          setCurrentTime(now);
    }, 1000);
    
    return () => clearInterval(timer);
  }, [masjidTimeZone]);

  return (
    <div className="px-[1.8svh] mb-[3svh]">
      <div className="bg-green-50 text-center pb-1 rounded-lg shadow-md">
        {/* 🕒 Current Time */}
        <div className="">
          <span className="text-[9svh] font-semibold font-sans">
            {currentTime.format("hh:mm").replace(/^0(\d):/, "$1:")}
          </span>
          <span className="text-[5svh] ml-[1.5svh]">
            {currentTime.format("A")}
          </span>
        </div>

        {/* 📅 Gregorian + Hijri Date */}
        <div className="text-[2.5svh] text-gray-500 flex justify-center gap-2 uppercase">
          <span>{currentTime.format("dddd, MMM DD")}</span>
          <span>|</span>
          <span>{hijriDate}</span>
        </div>
      </div>
    </div>
  );
};

export default CurrentTimeDisplay;